import { ActionCenterTask, ActionCenterTaskType } from '@domain'

export const actionCenterTasks: ActionCenterTask[] = [
	{
		task: ActionCenterTaskType.PACK_CONVERSION,
		title: 'Review Pack Size Conversions',
		subtitle: 'Confirm pack size conversions for matches over the threshold.',
		actionLabel: 'Review pack size conversions',
		step: 1,
		completed: true,
	},
	{
		task: ActionCenterTaskType.DIRECT_DEALS,
		title: 'Review Direct Deals',
		subtitle: 'Review and approve direct deal switches.',
		actionLabel: 'Review Direct Deals',
		step: 2,
		completed: false,
	},
]
